// 热榜首页专用：裁剪字段并做页面所需的格式化，不复用 services/api 的 formatHotNewsData
const HOT_NEWS_TYPES_MAP = {
    short: 'shortCustom',
    doc: 'article',
    phvideo: 'video',
    topic2: 'topic',
};

export const pickHotNewsListItem = item => {
    if (!item) return item;

    const picked = {
        documentId: item.documentId,
        id: item.id,
        type: item.type,
        title: item.title,
        source: item.subscribe && item.subscribe.catename ? item.subscribe.catename : item.source,
        thumbnail: item.thumbnail,
        link: item.link && {
            type: item.link.type,
            url: item.link.url,
            weburl: item.link.weburl,
        },
        hotLabel: item.hotLabel && {
            hotTrend: item.hotLabel.hotTrend,
            hotGrade: item.hotLabel.hotGrade,
            desp: item.hotLabel.desp,
            link: item.hotLabel.link && {
                type: item.hotLabel.link.type,
                url: item.hotLabel.link.url,
                weburl: item.hotLabel.link.weburl,
            },
        },
    };

    if (item.style && item.style.attachIcon) {
        picked.style = { attachIcon: item.style.attachIcon };
    }

    if (item.phvideo && item.phvideo.length != null) {
        picked.phvideo = { length: item.phvideo.length };
    }

    return picked;
};

export const formatHotNewsList = (listData = []) => {
    if (!Array.isArray(listData)) return listData;

    return listData.map(item => {
        const picked = pickHotNewsListItem(item);

        return {
            ...picked,
            base62Id: item.id && item.id.replace ? item.id.replace('ucms_', '') : '',
            url: item.link && item.link.weburl,
            type: HOT_NEWS_TYPES_MAP[item.type] || item.type,
            clickCount: {
                behavior: 'action',
                type: 'openNewsapp',
                other: {
                    ref: `${item.id}`,
                    kind: 'article',
                },
            },
        };
    });
};
